import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CMSService {
  private readonly http = inject(HttpClient);

  getCMSData(): Observable<object> {
    return this.http.get('https://mortgageclubsandbox.z33.web.core.windows.net/clubhub-prod-lender-banners.json');
  }
}
